<template>
    <Progressbar
        :visible="visible"
        :max="max"
        :current="current"
    />
</template>

<style scoped>
#progressbar-container {
    position: fixed;
}
</style>

<script>
import Progressbar from "./Progressbar.vue";
import eventbus from "@eventbus";

export default {
    name: "FooterProgressBar",
    components: { Progressbar },
    data() {
        return {
            current: 1,
            max: 1,
            visible: false,
        };
    },
    computed: {
        percentage() {
            return (this.current / this.max) * 100;
        },
        width() {
            return "width: " + this.percentage + "%;";
        },
    },
    watch: {
        data(data) {
            this.setData(data);
        },
    },
    mounted() {
        eventbus.on("progressbar-set-max", this.set_max);
        eventbus.on("progressbar-set-current", this.set_current);
        eventbus.on("progressbar-visible", this.set_visible);
    },
    unmounted() {
        eventbus.off("progressbar-set-max", this.set_max);
        eventbus.off("progressbar-set-current", this.set_current);
        eventbus.off("progressbar-visible", this.set_visible);
    },
    methods: {
        set_current(current) {
            this.current = current;
        },
        set_max(max) {
            this.max = max;
        },
        set_visible(val) {
            this.visible = val;
        },
        setData(data) {
            this.visible = data.visible;
            this.max = data.max;
            this.current = data.current;
        },
    },
};
</script>
